import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import { Card, LinkedAccount, Transaction } from "model";
import React from "react";
/**
 * @function AutopayPage
 * @return {React.Component}
 * @exported true
 * @description The main component for AutopayPage.
 * Available routes:
 * <EnterAutopayView />
 * <ActivatedAutopayView />
 */
export default function AutopayPage(props) {
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor([ Card ,LinkedAccount,Transaction ], globalController);
   
  return (
    <MainContentContainer className="autopay-page main-content-section" header={ <MainContentHeader text="Autopay" />  }>
     {props.view}
    </MainContentContainer>
  )
}
